import SchoolLeader from './SchoolLeader';

export default SchoolLeader;
